var _ = require('underscore');

module.exports = {


  /**
   * Call to initially setup the data cache
   * @param data
   * @param cacheMap
   */
  initializeDataCache: function(data, cacheMap) {
    if (!cacheMap) {
      return;
    }

    this.dataCache = {};
    this.ensureDataCache(data, cacheMap);
  },


  /**
   * Ensure we have collections setup for the given data, using cacheMap as a guide
   * @param data
   * @param cacheMap
   */
  ensureDataCache: function(data, cacheMap, accumulate) {
    if (!cacheMap) {
      return;
    }

    _.each(cacheMap, function(collection, key) {
      if (data[key]) {
        if (!this.dataCache[key]) {
          this.dataCache[key] = new collection(data[key]);
        }
        else {
          this.dataCache[key].set(data[key], {remove: !accumulate});
        }

      }
    }, this);
  },


  /**
   * Get a cached model on a given collection
   * @param collectionKey
   * @param where Object to pass into findWhere(where) on cache collection or String/Number ID to pass into get(where)
   * @param all allow to use where rather than findWhere
   * @return {Model|null}
   */
  getCachedData: function(collectionKey, where, all) {
    var cachedCollection;
    var parent;
    var data = null;

    // Do we actually have any cache?
    if (this.dataCache && (cachedCollection = this.dataCache[collectionKey])) {
      data = _.isObject(where)
        ? all ? cachedCollection.where(where) : cachedCollection.findWhere(where)
        : cachedCollection.get(where);

      if (data) {
        return data;
      }
    }

    // Try and use our parent to retrieve data
    if (parent = this.getDataCacheParent()) {
      return parent.getCachedData(collectionKey, where, all);
    }

    return null;
  },


  /**
   * Method to return a parent object where dataCache mixin is implemented
   * Useful to implement this where you would like to search for data
   * @returns {null}
   */
  getDataCacheParent: function() {
    return this.collection || null;
  }
};



// WEBPACK FOOTER //
// ./app/assets/js/mixins/dataCache.js